export const filterLatestConnections = (connectedTrackers) =>
  Object.values(
    connectedTrackers.reduce((acc, item) => {
      if (!acc[item.provider] || item.last_synced_at > acc[item.provider].last_synced_at) {
        acc[item.provider] = item
      }
      return acc
    }, {})
  )
